<template>
  <div class="nl-single" :class="{ 'nl-single--riv': isRiv }">
    <div class="nl-single__card">
      <!-- For riv, ProductLogo renders the .logo-container black band + reseller logo,
           themed per reseller via resellers.scss -->
      <ProductLogo class="nl-single__header" />
      <main class="nl-single__body" role="main">
        <slot />
      </main>
    </div>
  </div>
</template>

<script>
import ProductLogo from '@/elements/ProductLogo.vue'
import { getProductName } from '@/utils/url'

export default {
  name: 'LoginSingleLayout',
  components: {
    ProductLogo
  },
  computed: {
    // riv is the only product whose header is a solid coloured brand block;
    // on mobile it goes full-bleed (see the --riv modifier in styles).
    isRiv () {
      return getProductName() === 'riv'
    }
  }
}
</script>

<style lang="scss" scoped>
.nl-single {
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: $spacer*3 $spacer;

  &__card {
    width: 100%;
    max-width: 520px;
    background-color: $nl-surface;
    border-radius: 16px;
    box-shadow: $nl-card-shadow;
    overflow: hidden;
  }

  // For riv, ProductLogo's .logo-container is the brand band. Render it as a
  // solid, full-width filled colour block (per Figma) flush to the top of the
  // card, with the reseller logo centred. We drop the per-reseller padding
  // (which pins the logo to the top edge) in favour of a fixed band height and
  // flex centring, so every brand gets the same balanced block regardless of
  // its logo dimensions.
  &__header ::v-deep .logo-container {
    margin: 0;
    padding: 0;
    min-height: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__body {
    padding: $spacer $spacer*3 $spacer*4;
  }

  // On mobile the card chrome disappears: content sits directly on the plain
  // white page at the standard 16px side margins (per Figma).
  @include media-breakpoint-down(sm) {
    align-items: flex-start;
    &__card {
      background-color: transparent;
      border-radius: 0;
      box-shadow: none;
      overflow: visible;
      max-width: 100vw;
    }

    &__body {
      padding: $spacer*3 0 $spacer*4;
    }
  }

  // riv: the coloured brand header is a full-bleed block. On mobile the card
  // chrome is already gone, so drop the page gutter to let the block reach the
  // screen edges and sit flush to the top. The body keeps its own side inset so
  // the form fields stay 16px from the edge (per Figma).
  &--riv {
    @include media-breakpoint-down(sm) {
      padding: 0;

      .nl-single__body {
        padding-left: $spacer;
        padding-right: $spacer;
      }
    }
  }
}
</style>
